import React from 'react';
import { ExternalLink } from 'lucide-react';

const Portfolio = () => {
  const projects = [
    {
      title: 'E-commerce de Luxo',
      category: 'Loja Virtual',
      image:'foto01.png',
      description: 'Plataforma completa de vendas online com painel administrativo'
    },
    {
      title: 'Landing Page Imobiliária',
      category: 'Página de Vendas',
      image:"foto02.png",
      description: 'Alta taxa de conversão com integração CRM'
    },
    {
      title: 'Site Corporativo',
      category: 'Institucional',
      image:"foto03.png",
      description: 'Presença digital profissional para consultoria'
    },
    {
      title: 'Portfolio Arquitetura',
      category: 'Showcase',
      image:"foto04.png",
      description: 'Galeria interativa com efeitos visuais premium'
    },
    {
      title: 'Plataforma SaaS',
      category: 'Aplicação Web',
      image:"foto05.png",
      description: 'Sistema completo de gestão empresarial'
    },
    {
      title: 'Blog de Viagens',
      category: 'Content Hub',
      image: "foto06.png",
      description: 'Plataforma de conteúdo com SEO avançado'
    }
  ];

  return (
    <section id="portfolio" style={{
      padding: '120px 40px',
      background: '#000000'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div className="fade-in" style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 className="section-title">
            Projetos que <span className="gold-gradient">Inspiram</span>
          </h2>
          <p className="section-subtitle" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Cada projeto é uma história de sucesso. Veja alguns exemplos do nosso trabalho
            que transformaram a presença digital de nossos clientes.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '40px'
        }}>
          {projects.map((project, idx) => (
            <div
              key={idx}
              className="fade-in portfolio-item"
              style={{
                position: 'relative',
                borderRadius: '12px',
                overflow: 'hidden',
                background: 'linear-gradient(145deg, rgba(212, 175, 55, 0.05) 0%, transparent 100%)',
                border: '1px solid rgba(212, 175, 55, 0.2)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                transitionDelay: `${idx * 0.1}s`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(212, 175, 55, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              {/* Image */}
              <div style={{
                width: '100%',
                height: '300px',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <img
                  src={`/${project.image}`}
                  alt={project.title}
                  className="portfolio-image"
                  style={{
                    width: '100%',
                    height: '80%',
                    objectFit: 'cover',
                    transition: 'transform 0.3s ease'
                  }}
                />
                <div className="portfolio-overlay">
                  <ExternalLink size={48} color="#FFFFFF" />
                </div>
                <div style={{
                  position: 'absolute',
                  top: '20px',
                  left: '20px',
                  background: 'rgba(212, 175, 55, 0.9)',
                  color: '#000000',
                  padding: '6px 16px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: '600',
                  letterSpacing: '1px'
                }}>
                  {project.category}
                </div>
              </div>

              {/* Content */}
              <div style={{ padding: '30px' }}>
                <h3 style={{
                  fontFamily: 'Playfair Display, serif',
                  fontSize: '24px',
                  fontWeight: '600',
                  marginBottom: '12px',
                  color: '#FFFFFF'
                }}>
                  {project.title}
                </h3>
                <p style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '14px',
                  fontWeight: '300',
                  color: '#CCCCCC',
                  lineHeight: '1.6',
                  marginBottom: '20px'
                }}>
                  {project.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="fade-in" style={{
          textAlign: 'center',
          marginTop: '80px',
          transitionDelay: '0.8s'
        }}>
          <p style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '18px',
            fontWeight: '300',
            color: '#CCCCCC',
            marginBottom: '30px'
          }}>
            Pronto para ter um projeto como estes?
          </p>
          <button
            onClick={() => window.open('https://wa.me/5562995664918?text=Olá! Vi o portfólio e gostaria de um projeto similar.', '_blank')}
            className="btn-primary shimmer"
          >
            INICIAR MEU PROJETO
          </button>
        </div>
      </div>

      <style>{`
        .portfolio-item .portfolio-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        .portfolio-item:hover .portfolio-image {
          transform: scale(1.05);
        }
        .portfolio-item:hover .portfolio-overlay {
          opacity: 1;
        }
        @media (max-width: 768px) {
          #portfolio > div > div:nth-child(2) {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Portfolio;